import React, { Component } from 'react';
import Input from "./Input";
import iconUsername from '../assets/icon-username.png';
import iconPassword from '../assets/icon-password.png';
import iconUsernamePlaceholder from '../assets/icon-username-placeholder.png';
import iconPasswordPlaceholder from '../assets/icon-password-placeholder.png';

import sellerPic from '../assets/pic-seller.png';

/**
 * 登录表格
 */
class LoginForm extends Component {

  state = {
    userNameError: '',
    passwordError: '',

    username: '',
    password: '',
    submitting: false,
    imageOpacity: 1,
    imageVisible: true,
    source: 'new',
  };

  componentDidMount() {
    // 页面适配
    const resizeCallback = () => {
      const {imageVisible} = this.state;
      if (window.innerWidth < 1020 && imageVisible) {
        this.setState({
          imageVisible: false
        });
      } else if (window.innerWidth >= 1020 && !imageVisible) {
        this.setState({
          imageVisible: true
        });
      }
    };
    resizeCallback();
    window.addEventListener("resize", resizeCallback);
  }

  handleSubmit = () => {
    const {username, password, submitting} = this.state;
    if (!username) {
      this.setState({
        userNameError: '用户名不能为空'
      });
      return;
    }
    if (!password) {
      this.setState({
        passwordError: '密码不能为空'
      });
      return;
    }
    if (submitting) {
      return;
    }

    this.setState({
      submitting: true,
      userNameError: '',
      passwordError: '',
    });
    const data = new FormData();
    data.append("username", username);
    data.append("password", password);
    fetch(`/sso/auth`, {
      headers: {},
      method: 'POST',
      // redirect: 'follow',
      credentials: 'include',
      body: data,
    }).then((res) => {
      setTimeout(() => {
        this.setState({
          submitting: false
        });
      }, 600);

      switch (res.status) {
        case 401:
          res.json().then(json => {
            this.setState({
              userNameError: json.message.indexOf('用户') > -1 ? json.message : '',
              passwordError: json.message.indexOf('密码') > -1 ? json.message : '',
            });
          });
          break;
        case 200:
          // 保存角色
          res.text().then(url => {
            if (url.startsWith('http')) {
              window.location = url;
            } else {
              window.location.href = url;
            }
          });
          break;
        default:
          this.setState({
            userNameError: '系统异常，请联系管理员',
          });
      }
    });
  };

  render() {
    const {
      username,
      password,
      userNameError,
      passwordError,
      submitting,
      imageOpacity,
      imageVisible,
    } = this.state;
    const maxWindowWith = window.innerWidth - 60;
    const maxWindowHeight = window.innerHeight - 220;
    const smallSize = 600 - maxWindowHeight;
    return (
      <div className="login-container"
           style={{
             position: 'relative',
             maxWidth: maxWindowWith > 1020 ? 1020 : maxWindowWith,
             height: maxWindowHeight > 600 ? 600 : maxWindowHeight,
             backgroundColor: 'RGBA(248, 250, 252, 0.88)',
             boxShadow: '0px 0px 50px 0px rgba(0,0,0,0.2)',
           }}>
        <div style={{
          zIndex: -1,
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'inherit',
        }}/>
        <div style={{display: 'flex', height: '100%', fontSize: 14, zIndex: 3}}>
          <div style={{
            textAlign: 'center',
            flex: 1,
            width: '100%',
            height: '100%',
            padding: '0 30px',
            display: 'flex',
            justifyContent: 'start',
            flexDirection: 'column',
            alignItems: 'start',
          }}>
            <div style={{height: Math.min(80, Math.max(80 - smallSize, 40))}}/>
            <div style={{
              color: '#222222',
              fontSize: '2.2em',
              maxWidth: '100%',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              width: '100%'
            }}>快售宝智慧门店
            </div>
            <div style={{
              color: '#222222',
              fontSize: '2.2em',
              maxWidth: '100%',
              textAlign: 'left',
              width: '100%'
            }}>管理系统
            </div>
            <div style={{flex: 1}}/>
            <div
              style={{
                maxWidth: '100%',
                color: '#9CA6C0',
                fontSize: '1.1em',
                marginBottom: 12,
                textAlign: 'left'
              }}>请输入您的登录账号和密码
            </div>
            <Input placeholder='账号'
                   error={userNameError}
                   value={username}
                   icon={username ? iconUsername : iconUsernamePlaceholder}
                   maxLength={30}
                   style={{
                     borderBottom: '1px sold #EFEFF5',
                     zIndex: 2
                   }}
                   onChange={(v) => {
                     this.setState({username: v, userNameError: ''});
                   }}/>

            <Input placeholder='密码' value={password}
                   icon={password ? iconPassword : iconPasswordPlaceholder}
                   error={passwordError}
                   maxLength={32}
                   type='password'
                   onChange={(v) => {
                     this.setState({password: v, passwordError: ''});
                   }}
                   style={{borderTopWidth: 'thin', zIndex: 1}}
                   onEnter={this.handleSubmit}
            />
            <div style={{marginTop: 24, width: '100%', display: 'flex'}}>
              <div
                className={'login-btn ' + (submitting ? 'animating' : '')}
                onClick={this.handleSubmit}
                style={{
                  width: '100%',
                  height: 46,
                  lineHeight: '46px',
                  textAlign: 'center',
                  fontSize: 16,
                  color: '#fff',
                  cursor: 'pointer',
                }}>{submitting ? '登录中...' : '登录'}
              </div>
              {/*<div>*/}
              {/*忘记密码？*/}
              {/*</div>*/}
            </div>

            <div style={{height: 60}}/>
          </div>
          <div style={{width: 600, display: imageVisible ? 'block' : 'none'}}>
            <img src={sellerPic} alt=''
                 style={{
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   opacity: imageOpacity,
                   transition: 'all 0.1s ease'
                 }}/>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm.js